import { Text } from '@ui/atoms';
import React from 'react';
import texts from '@components/ReferAndEarn/en.json';

const DoubleRewardsBanner = () => {
    return (
        <div className="mx-auto mt-8 md:mt-12 px-4 md:px-6 xl:px-0 max-w-[769px] w-full">
            <div className="flex flex-col overflow-hidden rounded-lg xl:rounded-2xl border border-[#D7BC5F] bg-gradient-radial from-white to-secondary-50 shadow-2xl">
                <div className="flex flex-col items-center gap-2 px-4 py-6 md:py-8 bg-gradient-gold-radial">
                    <Text
                        content={texts?.DoubleRewardsBanner?.heading}
                        className="text-center text-transparent text-primary-600 h4-semibold md:h3-semibold bg-gradient-to-br from-gradientBlue to-primary-500 bg-clip-text "
                        htmlTag="h3"
                    />
                    <Text
                        content={texts?.DoubleRewardsBanner?.subHeading}
                        className="text-center text-gray-600 p5-medium md:p4-medium"
                        htmlTag="p"
                    />
                </div>
                <div className="flex flex-col gap-2 px-6 py-3 md:py-2 bg-gradient-gold-horizontal">
                    <Text
                        content={texts?.DoubleRewardsBanner?.offer}
                        className="text-center text-transparent bg-gradient-to-br from-gradientBlue to-primary-500 bg-clip-text h7-semibold md:h6-semibold"
                        htmlTag="p"
                    />
                </div>
            </div>
        </div>
    );
};

export default DoubleRewardsBanner;
